/* ===========================================
   CART ANIMATION - LP Seabra
   Adiciona ao carrinho SEM redirecionar
   Clique no carrinho abre drawer
   =========================================== */

(function() {
  'use strict';

  let cartIcon = null;
  let cartCount = null;
  let isProcessing = false;

  function init() {
    cartIcon = document.querySelector('.lp-header__icon-wrapper[href*="cart"]');
    cartCount = document.querySelector('.lp-header__cart-count, cart-count');

    if (!cartIcon || !cartCount) {
      setTimeout(init, 500);
      return;
    }

    interceptAllAddToCart();
  }

  // Intercepta TODOS os formulários de adicionar ao carrinho
  function interceptAllAddToCart() {
    document.addEventListener('submit', function(e) {
      const form = e.target;

      if (form.matches('form[action*="/cart/add"], [is="product-form"]')) {
        e.preventDefault();
        e.stopPropagation();
        
        // Previne duplo clique
        if (isProcessing) return;
        
        addToCartAjax(form);
      }
    }, true);
  }

  // Adiciona ao carrinho via AJAX
  function addToCartAjax(form, clickedButton) {
    if (isProcessing) return;
    isProcessing = true;
    
    const formData = new FormData(form);
    const button = clickedButton || form.querySelector('button[type="submit"], input[type="submit"]');

    // Feedback no botão quick-buy
    if (button && button.classList.contains('product-item__quick-buy-button')) {
      button.classList.add('added');
      setTimeout(() => button.classList.remove('added'), 1000);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) throw new Error('Erro ao adicionar');
      return response.json();
    })
    .then(data => {
      updateCartCount();
      triggerCartAnimation();
    })
    .catch(error => {
      console.error('Erro:', error);
    })
    .finally(() => {
      setTimeout(() => { isProcessing = false; }, 500);
    });
  }

  // Atualiza o contador do carrinho
  function updateCartCount() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }
    });
  }

  // Dispara animação no ícone do carrinho
  function triggerCartAnimation() {
    if (!cartIcon || !cartCount) return;

    cartCount.classList.remove('cart-added', 'cart-highlight');
    cartIcon.classList.remove('cart-bounce');

    void cartCount.offsetWidth;

    cartCount.classList.add('cart-added', 'cart-highlight');
    cartIcon.classList.add('cart-bounce');

    setTimeout(() => cartCount.classList.remove('cart-highlight'), 300);
    setTimeout(() => {
      cartCount.classList.remove('cart-added');
      cartIcon.classList.remove('cart-bounce');
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', () => setTimeout(init, 100));

})();
